module.exports = __webpack_public_path__ + "b28d4bf62a8c434d6b475e668aa9e7d1.pdf";